import styled from 'styled-components';
import { Button } from '@adobe/react-spectrum';

export const Section = styled.div`
  margin-top: 20px;
  display: flex;
`;

export const LaunchDateTime = styled.div`
  display: flex;
  margin-top: 20px;
`;
export const Actions = styled.div`
  position: relative;
  width: 100%;
`;

export const Time = styled.span`
  float: right;
  margin-left: 36px;
`;

export const TimeSection = styled.span`
  align-self: flex-end;
`;

export const Page = styled.span`
  float: right;
  height: 15px;
  margin: 12px 92px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #8e8e8e;
`;

export const MultiSelect = styled.div`
  ._spectrum-FieldLabel_36b9b {
    font-size: 12.5px;
  }
  .asterisk {
    margin: 0px 0px 0px 5px;
    font-size: 19px;
    height: 2px;
    color: gray;
    font-weight: 100;
  }
`;

export const customStyles = {
  option: provided => ({
    ...provided,
    width: '461px',
  }),
  menu: provided => ({
    ...provided,
    width: '461px',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  control: provided => ({
    ...provided,
    width: '461px',
    height: '32px',
    minHeight: '32px',
    color: 'yellow',
  }),
  placeholder: provided => ({
    ...provided,
    width: 'fit-content',
    height: '17px',
    margin: '-3px 0px -1px 1px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontSize: '14px',
    fontStyle: 'italic',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#8e8e8e',
  }),
};

export const Submit = styled(Button)``;

export const Title = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const Content = styled.div`
  margin-left: 40px;
`;

export const Wrap = styled.div`
  display: flex;

  .wrapper-class {
    display: flex;
    flex-direction: column-reverse;
  }

  .editor-class {
    overflow: hidden;
    width: 751px;
    height: 100%;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px 5px 0 0;
  }

  .toolbar-class {
    width: 739px;
    border: 1px solid #ccc;
    border-radius: 0 0 5px 5px;
  }
`;

export const Container = styled.div`
  height: 100%;
  min-width: 65%;
  min-height: 780px;
  background-color: white;
  margin: 25px 25px;
  padding: 0 25px 25px 40px;
  border-radius: 4px;
  box-shadow: 0 0 1px #eaeaea inset;
`;

export default Wrap;
